<template>
  <div>
     <vue-header/>
     <loading :active.sync="isLoading"
          :can-cancel="false"
          :width = "50"
          :height = "50"
          :is-full-page="true">
          </loading>
    <div class="wd-container" style="margin-top: 15px;text-align:left;background-color: #F3F3F3;">
    <div class="container" style="background-color:#F3F3F3">
       <router-link :to="'/'+previousUrl" tag="button">
         <i class="fa fa-arrow-circle-left" style="font-size:25px;margin-bottom:10px;cursor:pointer;" ></i>
          </router-link>
          <div class="card">
            <div class="card-header bg-dark text-white" style="text-align:center;">
              <h1 style="font-size:18px;">Add New Job</h1>
            </div>
          </div>
          <!---------------------------------- Job Account ------------------------------------------------>
          <b-card  header="Set Account">
            <b-row class="my-1">
              <b-col sm="12">
                <label for="input-default">Account<span style="color:red;">*</span></label>
              </b-col>
              <b-col sm="12" class="mb-2 mt-2" v-if="accountFlag=='default'">
                <button type="submit" class="btn btn-save shadow" style="width:100%;" @click="addNewJobModal">Create New Account</button>
                </b-col>
                 <b-col sm="12" v-if="accountFlag=='default'">
                <button type="submit" class="btn btn-save shadow" style="width:100%;" @click="selectAccountModal">Select Existing</button>
                </b-col>
              <b-col sm="12" v-if="accountFlag=='selected'"  class="mt-2">
                <input class="wd-edited" readonly v-model="selectedAccount.name" type="text" id="accountTitle">
                </b-col>
              <b-col sm="12" class="mt-2" v-if="accountFlag=='selected'" >
                <label for="input-default">Primary Contact</label>
              </b-col>

               <b-col sm="12" v-if="accountFlag=='selected'"  class="mt-2">
                <b-form-select class="shadow-sm mb-1" v-model="jobData.primary_contact" style="color: black;">
                      <option v-for="(val, indexOpt) in selectedContact"
                            :key="val.id"
                            v-bind:value="val.id"
                        >
                            {{ val.primary_contact_name }}
                        </option>
                    </b-form-select>
              </b-col>
            </b-row>
          </b-card>
          <!---------------------------------- Job INfo ------------------------------------------------>
          <b-card  header="Job Info">
            <b-row class="my-1">
                  <b-col sm="2">
                    <label for="input-default">Job Name<span style="color:red;">*</span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input id="input-default" class="shadow-sm p-3 mb-1 bg-white rounded"
                    v-model="jobData.name"
                    autocomplete="off"
                    ></b-form-input>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">Job Number<span style="color:red;">*</span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input id="input-default" class="shadow-sm p-3 mb-1 bg-white rounded"
                    v-model="jobData.job_number"
                    autocomplete="off"
                    ></b-form-input>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">Current Status<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-select class="shadow-sm mb-1" v-model="jobData.status" :options="status_options" style="color: black;"></b-form-select>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">Bid Date<span style="color:red;">*</span></label>
                  </b-col>
                  <b-col sm="10">
                    <datetime v-model="jobData.bidDate" format="MM/dd/yyyy"></datetime>
                  </b-col>
                </b-row>
          </b-card>



          <!---------------------------------- Address ------------------------------------------------>


          <b-card  header="Addresses">
            <b-row class="my-1">
                  <b-col sm="12">
                    <label for="input-default"  class="mb-2 mt-2"><b>Site Address</b></label>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">Address<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input id="input-default" class="shadow-sm p-3 mb-1 bg-white rounded"
                    v-model="jobData.site_address_1"
                    autocomplete="off"
                    ></b-form-input>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">Address 2<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input id="input-default" class="shadow-sm p-3 mb-1 bg-white rounded"
                    v-model="jobData.site_address_2"
                    autocomplete="off"
                    ></b-form-input>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">City<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input id="input-default" class="shadow-sm p-3 mb-1 bg-white rounded"
                    v-model="jobData.site_city"
                    autocomplete="off"
                    ></b-form-input>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">State<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-select class="shadow-sm mb-1" v-model="jobData.site_state" :options="contactStates" style="color: black;"></b-form-select>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">Zip<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input id="input-default" class="shadow-sm p-3 mb-1 bg-white rounded"
                    v-model="jobData.site_zip"
                    autocomplete="off"
                    ></b-form-input>
                  </b-col>
                  <b-col sm="12" class="mb-2 mt-2">
                    <label for="input-default"><b>Billing Address</b></label>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">Address<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input id="input-default" class="shadow-sm p-3 mb-1 bg-white rounded"
                    v-model="jobData.billing_address_1"
                    autocomplete="off"
                    ></b-form-input>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">Address 2<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input id="input-default" class="shadow-sm p-3 mb-1 bg-white rounded"
                    v-model="jobData.billing_address_2"
                    autocomplete="off"
                    ></b-form-input>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">City<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input id="input-default" class="shadow-sm p-3 mb-1 bg-white rounded"
                    v-model="jobData.billing_city"
                    autocomplete="off"
                    ></b-form-input>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">State<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">

                    <b-form-select class="shadow-sm mb-1" v-model="jobData.billing_state" :options="contactStates" style="color: black;"></b-form-select>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">Zip<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input id="input-default" class="shadow-sm p-3 mb-1 bg-white rounded"
                    v-model="jobData.billing_zip"
                    autocomplete="off"
                    ></b-form-input>
                  </b-col>
                </b-row>
          </b-card>


          <!---------------------------------- Project Roles ------------------------------------------------>


          <b-card  header="Project Roles">
            <b-row class="my-1">
                  <b-col sm="2">
                    <label for="input-default">Estimator<span style="color:red;">*</span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-select class="shadow-sm mb-1" v-model="jobData.estimator" style="color: black;">
                      <option v-for="(val, indexOpt) in estimator_options"
                            :key="val.id"
                            v-bind:value="val.id"
                        >
                            {{ val.value }}
                        </option>
                    </b-form-select>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">Project Manager<span style="color:red;">*</span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-select class="shadow-sm mb-1" v-model="jobData.project_manager"  style="color: black;">
                      <option v-for="(val, indexOpt) in project_manager_options"
                            :key="val.id"
                            v-bind:value="val.id"
                        >
                            {{ val.value }}
                        </option>
                    </b-form-select>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">Foreman<span style="color:red;">*</span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-select class="shadow-sm mb-1" v-model="jobData.foreman"  style="color: black;">
                      <option v-for="(val, indexOpt) in foreman_options"
                            :key="val.id"
                            v-bind:value="val.id"
                        >
                            {{ val.value }}
                        </option>
                    </b-form-select>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">Accountant<span style="color:red;">*</span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-select class="shadow-sm mb-1" v-model="jobData.accounting" style="color: black;">
                      <option v-for="(val, indexOpt) in accountant_options"
                            :key="val.id"
                            v-bind:value="val.id"
                        >
                            {{ val.value }}
                        </option>
                    </b-form-select>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">Salesperson<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-select class="shadow-sm mb-1" v-model="jobData.salesman"  style="color: black;">
                       <option v-for="(val, indexOpt) in sales_person_options"
                            :key="val.id"
                            v-bind:value="val.id"
                        >
                            {{ val.value }}
                        </option>
                    </b-form-select>
                  </b-col>
                </b-row>
          </b-card>

          <!---------------------------------- Job Charecteristics ------------------------------------------------>


          <b-card  header="Job Characteristics">
            <b-row class="my-1">
                  <b-col sm="2">
                    <label for="input-default">Lead Source<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-select class="shadow-sm mb-1" v-model="jobData.lead_source" style="color: black;">
                        <option v-for="(val, indexOpt) in lead_source_options"
                            :key="val.id"
                            v-bind:value="val.id"
                        >
                            {{ val.value }}
                        </option>
                    </b-form-select>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">{{customDropdown1}}<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-select class="shadow-sm mb-1" v-model="jobData.custom_drop_1"  style="color: black;">
                      <option v-for="(val, indexOpt) in custom_drop_options_1"
                            :key="val.id"
                            v-bind:value="val.id"
                        >
                            {{ val.value }}
                        </option>
                    </b-form-select>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">{{customDropdown2}}<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-select class="shadow-sm mb-1" v-model="jobData.custom_drop_2"  style="color: black;">
                       <option v-for="(val, indexOpt) in custom_drop_options_2"
                            :key="val.id"
                            v-bind:value="val.id"
                        >
                            {{ val.value }}
                        </option>
                    </b-form-select>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">{{customDropdown3}}<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-select class="shadow-sm mb-1" v-model="jobData.custom_drop_3"  style="color: black;">
                       <option v-for="(val, indexOpt) in custom_drop_options_3"
                            :key="val.id"
                            v-bind:value="val.id"
                        >
                            {{ val.value }}
                        </option>
                    </b-form-select>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">{{customDropdown4}}<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-select class="shadow-sm mb-1" v-model="jobData.custom_drop_4"  style="color: black;">
                       <option v-for="(val, indexOpt) in custom_drop_options_4"
                            :key="val.id"
                            v-bind:value="val.id"
                        >
                            {{ val.value }}
                        </option>
                    </b-form-select>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">{{customDropdown5}}<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-select class="shadow-sm mb-1" v-model="jobData.custom_drop_5"  style="color: black;">
                       <option v-for="(val, indexOpt) in custom_drop_options_5"
                            :key="val.id"
                            v-bind:value="val.id"
                        >
                            {{ val.value }}
                        </option>
                    </b-form-select>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">{{customDropdown6}}<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-select class="shadow-sm mb-1" v-model="jobData.custom_drop_6"  style="color: black;">
                       <option v-for="(val, indexOpt) in custom_drop_options_6"
                            :key="val.id"
                            v-bind:value="val.id"
                        >
                            {{ val.value }}
                        </option>
                    </b-form-select>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">{{customField1}}<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input id="input-default" class="shadow-sm p-3 mb-1 bg-white rounded"
                    v-model="jobData.custom_text_1"
                    autocomplete="off"
                    ></b-form-input>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">{{customField2}}<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input id="input-default" class="shadow-sm p-3 mb-1 bg-white rounded"
                    v-model="jobData.custom_text_2"
                    autocomplete="off"
                    ></b-form-input>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">{{customField3}}<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input id="input-default" class="shadow-sm p-3 mb-1 bg-white rounded"
                    v-model="jobData.custom_text_3"
                    autocomplete="off"
                    ></b-form-input>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">{{customField4}}<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input id="input-default" class="shadow-sm p-3 mb-1 bg-white rounded"
                    v-model="jobData.custom_text_4"
                    autocomplete="off"
                    ></b-form-input>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">{{customField5}}<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input id="input-default" class="shadow-sm p-3 mb-1 bg-white rounded"
                    v-model="jobData.custom_text_5"
                    autocomplete="off"
                    ></b-form-input>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">{{customField6}}<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input id="input-default" class="shadow-sm p-3 mb-1 bg-white rounded"
                    v-model="jobData.custom_text_6"
                    autocomplete="off"
                    ></b-form-input>
                  </b-col>
                </b-row>
          </b-card>

          <!---------------------------------- Dates and Priorities ------------------------------------------------>


          <b-card  header="Dates and Priorities">
            <b-row class="my-1">
                  <b-col sm="2">
                    <label for="input-default">Estimator Deadline<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <datetime v-model="jobData.estimator_deadline" format="MM/dd/yyyy"></datetime>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">Estimator Priority<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-select class="shadow-sm mb-1" v-model="jobData.estimator_priority" :options="['Low', 'Medium', 'High']" style="color: black;"></b-form-select>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">Production Deadline<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <datetime v-model="jobData.production_deadline" format="MM/dd/yyyy"></datetime>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">Production Priority<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-select class="shadow-sm mb-1" v-model="jobData.production_priority" :options="['Low', 'Medium', 'High']" style="color: black;"></b-form-select>
                  </b-col>
                  <b-col sm="2">
                    <label for="input-default">Work Completed<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <datetime v-model="jobData.completed_date" format="MM/dd/yyyy"></datetime>
                  </b-col>
                </b-row>
          </b-card>

          <!---------------------------------- Progression Tracker ------------------------------------------------>


          <b-card  header="Progression Tracker">
            <b-row class="my-1">
                  <b-col sm="2">
                    <label for="input-default">Select Stage<span style="color:red;">*</span></label>
                  </b-col>
                  <b-col sm="10">
                     <b-form-select class="shadow-sm mb-1" v-model="jobData.progress_status" :options="progressionOptions" style="color: black;"></b-form-select>
                  </b-col>
                </b-row>
          </b-card>

          <!---------------------------------- Prime Contract ------------------------------------------------>


          <b-card  header="Prime Contract">
            <b-row class="my-1">
                  <b-col sm="2">
                    <label for="input-default">Enter Prime Contract<span style="color:red;"></span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input id="input-default" class="shadow-sm p-3 mb-1 bg-white rounded"
                    v-model="jobData.prime_contract"
                    autocomplete="off"
                    ></b-form-input>
                  </b-col>
                </b-row>
          </b-card>
          <div class="clearfix"></div>
          <b-card >
          <div class="form-group" style="text-align: center;margin-top:8px;margin-bottom:15px;">
          <button type="submit" class="btn btn-save shadow" @click="validateData"> Save  </button>
          </div>
          </b-card>
        <b-modal ref="my-modal-add"  title="Using Component Methods">
            <template v-slot:modal-header="{  }">

             <div class="row" style="width: 100%;">
              <div class="col-12">
                <div >
                  <i class="material-icons float-left" style="font-size: 42px;margin-right: 8px;color: #303032;">
                    perm_contact_calendar
                  </i>
                </div>
                <div class="wd-modal-subheader">
                  <h3 style="font-size: 18px;font-weight: 300;color: #303032;margin: 0;">Account</h3>
                </div>
              </div>
            </div>
            </template>
            <div class="wd-modal-body p-l-20 p-r-20">
              <div class="row">
                <div class="col-sm-12">
                    <div class="wd-text-input">
                      <label for="accountName">Account Name*</label>
                      <input v-model="account.name" type="text" id="accountName" autofocus>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="wd-text-input">
                      <label for="accountEmail">Email</label>
                      <input v-model="account.email" type="text" id="accountEmail">
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="wd-text-input">
                      <label for="accountPhone">Phone</label>
                      <input v-model="account.phone" type="text" id="accountPhone"
                             v-mask="'(###)###-####'">
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="wd-text-input">
                      <label for="accountMobile">Mobile Number</label>
                      <input v-model="account.mobile" type="text" id="accountMobile"
                             v-mask="'(###)###-####'">
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="wd-text-input">
                      <label for="accountFax">Fax Number</label>
                      <input v-model="account.fax" type="text" id="accountFax"
                             v-mask="'(###)###-####'">
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="wd-text-input">
                      <label for="accountAddress1">Address</label>
                      <input v-model="account.address1" type="text" id="accountAddress1">
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="wd-text-input">
                      <label for="accountAddress2">Address2</label>
                      <input v-model="account.address2" type="text" id="accountAddress2">
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="wd-text-input">
                      <label for="accountCity">City</label>
                      <input v-model="account.city" type="text" id="accountCity">
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="wd-v-select">
                      <label class="wd-v-select-label">Account State</label>
                      <b-form-select class="shadow-sm mb-1" v-model="account.state" :options="contactStates" style="color: black;"></b-form-select>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="wd-text-input">
                      <label for="accountZip">Zip Code</label>
                      <input v-model="account.zip" type="number" id="accountZip">
                    </div>
                  </div>
                  <div class="col-sm-2">
                    <div class="wd-v-select">
                      <label class="wd-v-select-label" for="accountStatus">Status</label>
                      <b-form-select class="shadow-sm mb-1" v-model="account.status" :options="['Active','Inactive']" style="color: black;"></b-form-select>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="wd-v-select">
                      <label class="wd-v-select-label">Salesperson</label>
                      <b-form-select class="shadow-sm mb-1" v-model="account.salesman" style="color: black;">
                        <option v-for="(val, indexOpt) in salesmanOpt"
                            :key="val.id"
                            v-bind:value="val.id"
                        >
                            {{ val.value }}
                        </option>

                      </b-form-select>
                    </div>
                  </div>
          </div>
          <br/>
                <h3 class="wd-module-card-title">New Contact
                 <button type="submit" class="btn btn-save shadow" style="width:auto; margin-left:15px;" @click="useAccount">Use Account</button>
                </h3>
                <div class="row">
                  <div class="col-sm-12">
                    <div class="wd-text-input">
                      <label for="contactTitle">Contact Title</label>
                      <input v-model="contact.title" type="text" id="contactTitle">
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="wd-text-input">
                      <label for="contactFirstName">Contact First Name*</label>
                      <input v-model="contact.firstName" type="text" id="contactFirstName">
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="wd-text-input">
                      <label for="contactLastName">Contact Last Name*</label>
                      <input v-model="contact.lastName" type="text" id="contactLastName">
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="wd-text-input">
                      <label for="contactEmail">Contact Email*</label>
                      <input v-model="contact.email" type="text" id="contactEmail">
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="wd-text-input">
                      <label for="contactPhone">Contact Phone</label>
                      <input v-model="contact.phone" type="text" id="contactPhone"
                             v-mask="'(###)###-####'">
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="wd-text-input">
                      <label for="contactMobile">Contact Mobile Number</label>
                      <input v-model="contact.mobile" type="text" id="contactMobile"
                             v-mask="'(###)###-####'">
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="wd-text-input">
                      <label for="contactFax">Contact Fax Number</label>
                      <input v-model="contact.fax" type="text" id="contactFax"
                             v-mask="'(###)###-####'">
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="wd-text-input">
                      <label for="contactAddress1">Contact Address</label>
                      <input v-model="contact.address1" type="text" id="contactAddress1">
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="wd-text-input">
                      <label for="contactAddress2">Contact Address2</label>
                      <input v-model="contact.address2" type="text" id="contactAddress2">
                    </div>
                  </div>
                  <div class="col-sm-5">
                    <div class="wd-text-input">
                      <label for="contactCity">Contact City</label>
                      <input v-model="contact.city" type="text" id="contactCity">
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="wd-v-select">
                      <label class="wd-v-select-label">Contact
                        State</label>
                      <b-form-select class="shadow-sm mb-1" v-model="contact.state" :options="contactStates" style="color: black;"></b-form-select>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="wd-text-input">
                      <label for="contactZip">Contact Zip</label>
                      <input v-model="contact.zip" type="number" id="contactZip">
                    </div>
                  </div>
                </div>
            </div>
            <template v-slot:modal-footer="{  }">
              <b-button size="sm" class="btn btn-save" variant="save"  style="width:auto;" @click="addAccount">
                Create Account
              </b-button>
              <b-button size="sm" class="btn btn-save" variant="save" style="background-color: white; color: black;" @click="closeAddModal">
                Close
              </b-button>
            </template>
          </b-modal>


        <b-modal ref="my-modal-select"  title="Using Component Methods">
            <template v-slot:modal-header="{  }">

             <div class="row" style="width: 100%;">
              <div class="col-12">
                <div >
                  <i class="material-icons float-left" style="font-size: 42px;margin-right: 8px;color: #303032;">
                    perm_contact_calendar
                  </i>
                </div>
                <div class="wd-modal-subheader">
                  <h3 style="font-size: 18px;font-weight: 300;color: #303032;margin: 0;">Select Account</h3>
                </div>
              </div>
            </div>
            </template>
            <div class="wd-modal-body p-l-20 p-r-20">
              <div class="row">
                <div class="col-sm-12">
                      <label for="contactCity">Account</label>
                </div>
                <div class="col-sm-12">
                  <vue-bootstrap-typeahead
                    :minMatchingChars = 1
                    class="shadow-sm"
                    placeholder="Search Account"
                    :maxMatches = 100
                    ref="account"
                    v-model="existingAccount"
                    :serializer="item => item.value"
                    :data="account_options"
                    @hit="selectedAccountDrop($event)"
                    />
                </div>
              </div>
            </div>
            <template v-slot:modal-footer="{  }">
              <b-button size="sm" class="btn btn-save" variant="save"   @click="selectExistingAccount">
               OK
              </b-button>
              <b-button size="sm" class="btn btn-save" variant="save" style="background-color: white; color: black;" @click="closeSelectModal">
                Close
              </b-button>
            </template>
          </b-modal>

    </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import CommonConstants from '@/constants/constants.js'
import moment from 'moment'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
  components : {Loading,Datetime,VueBootstrapTypeahead},
  data() {
    return {
      constants: CommonConstants,
      isLoading: true,
      jobData : {
        name: '',
        job_number: null,
        bidDate: moment().format('YYYY-MM-DD'),
        status: 'request',
        progress_status:'',
        primary_contact : '',
        lead_source : '',
        custom_drop_1 : '',
        custom_drop_2 : '',
        custom_drop_3 : '',
        custom_drop_4 : '',
        custom_drop_5 : '',
        custom_drop_6 : '',
        custom_text_1: '',
        custom_text_2: '',
        custom_text_3: '',
        custom_text_4: '',
        custom_text_5: '',
        custom_text_6: '',
        estimator_deadline: '',
        estimator_priority: '',
        production_deadline: '',
        production_priority: '',
        completed_date: '',
        estimator: '',
        project_manager: '',
        foreman: '',
        accounting: '',
        salesman : '',
        prime_contract: '',
        site_address_1:'',
        site_address_2: '',
        site_city: '',
        site_state: '',
        site_zip: '',
        site_longitude: '',
        site_latitude: '',
        billing_address_1: '',
        billing_address_2: '',
        billing_city: '',
        billing_state: '',
        billing_zip: '',
      },
      account_options : [],
      job_option : [],
      status_options : [{value: "request", text: 'Request'}, {value: 'outstanding', text: 'Outstanding'},
          {value: 'contracted', text: 'Contracted'}, {value: 'proceed', text: 'Proceed'}
          , {value: 'scheduled', text: 'Scheduled'}, {value: 'completed', text: 'Completed'},
          {value: 'invoicing', text: 'Invoicing'}, {value: 'paid', text: 'Paid'}, {
            value: 'rejected',
            text: 'Rejected'
          }],
      contactStates: ['AL','AK','AZ','AR','CA','CO','CT','DE','DC','FL', 'GA','HI','ID','IL','IN','IA','KS','KY','LA', 'ME','MD','MA','MI', 'MN', 'MS','MO','MT','NE','NV','NH','NJ','NM','NY','NC','ND','OH','OK','OR','PA','RI', 'SC', 'SD','TN', 'TX', 'UT', 'VT', 'VA','WA', 'WV','WI','WY'
        ],
      progressionOptions:[
          { value: 'active',text : 'Active' },
          { value: 'inactive',text : 'Inactive' },
          { value: 'inprogress',text : 'In Progress' },
          { value: 'hold',text : 'Hold' },
      ],
      job_contacts_dropdown : [],
      estimator_options : [],
      project_manager_options : [],
      foreman_options : [],
      salesmanOpt : [],
      account: {
          name: '',
          email: '',
          phone: '',
          mobile: '',
          fax: '',
          address1: '',
          address2: '',
          city: '',
          state: '',
          zip: '',
          salesman : ''
        },
      contact: {
          title: '',
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          mobile: '',
          fax: '',
          address1: '',
          address2: '',
          city: '',
          state: '',
          zip: ''
        },
      existingAccount : '',
      accountFlag : 'default',
      selectedAccount : {
        name : '',
        id : ''
      },
      selectedContact : [],
      searchAccountContacts : '',
      accountant_options : [],
      sales_person_options : [],
      lead_source_options : [],
      custom_drop_options_1 : [],
      custom_drop_options_2 : [],
      custom_drop_options_3 : [],
      custom_drop_options_4 : [],
      custom_drop_options_5 : [],
      custom_drop_options_6 : [],
      customDropdown1 : '',
      customDropdown2 : '',
      googleMapLog: {
        address : '',
        api_status : "",
        api_response : ""
      },
      customDropdown3 : '',
      customDropdown4 : '',
      customDropdown5 : '',
      customDropdown6 : '',
      customField1 : '',
      customField2 : '',
      customField3 : '',
      customField4 : '',
      customField5 : '',
      customField6 : '',
      progressionValuesData : [],
      previousUrl : localStorage.getItem('previous_url') ? localStorage.getItem('previous_url') : 'jobs'

    }
  },
   mounted (){
    this.getFormData();
    this.job_option = JSON.parse(localStorage.getItem('jobs_status_json'));
  },
  methods : {
    getFormData (){
      let self = this;
      let header = {
        headers: {
          'Content-type': "application/json",
          'token': localStorage.getItem('token')
        }
      }
      axios.get(this.constants.api_url + 'job',header)
      .then(function (response) {
        if (response.data.flag) {
          console.log(response.data);
          self.account_options = response.data.data.accounts_dropdowns

          self.job_contacts_dropdown = response.data.data.job_contacts_dropdown;

          self.estimator_options = response.data.data.estimators;
          self.salesmanOpt = response.data.data.salesman;
          self.project_manager_options = response.data.data.project_managers
          self.foreman_options = response.data.data.foremen
          self.sales_person_options = response.data.data.salesman
          self.accountant_options = response.data.data.accountants
          self.lead_source_options = response.data.data.lead_sources
          let d = response.data.data;
          self.customField1 = response.data.data.company.custom_text_1;
          self.customField2 = response.data.data.company.custom_text_2;
          self.customField3 = response.data.data.company.custom_text_3;
          self.customField4 = response.data.data.company.custom_text_4;
          self.customField5 = response.data.data.company.custom_text_5;
          self.customField6 = response.data.data.company.custom_text_6;
          self.jobData.job_number = response.data.data.company.next_job_number;
          self.customDropdown1 = (typeof d.custom_fields_dropdowns[0] != 'undefined') ? d.custom_fields_dropdowns[0].drop_key : '';
          self.customDropdown2 = (typeof d.custom_fields_dropdowns[1] != 'undefined') ? d.custom_fields_dropdowns[1].drop_key : '';
          self.customDropdown3 = (typeof d.custom_fields_dropdowns[2] != 'undefined') ? d.custom_fields_dropdowns[2].drop_key : '';
          self.customDropdown4 = (typeof d.custom_fields_dropdowns[3] != 'undefined') ? d.custom_fields_dropdowns[3].drop_key : '';
          self.customDropdown5 = (typeof d.custom_fields_dropdowns[4] != 'undefined') ? d.custom_fields_dropdowns[4].drop_key : '';
          self.customDropdown6 = (typeof d.custom_fields_dropdowns[5] != 'undefined') ? d.custom_fields_dropdowns[5].drop_key : '';



          let industrySegments = (typeof d.custom_fields_dropdowns[0] != 'undefined')? d.custom_fields_dropdowns[0].drop_value : '';
            self.custom_drop_options_1 = industrySegments
          let bids = (typeof d.custom_fields_dropdowns[1] != 'undefined')? d.custom_fields_dropdowns[1].drop_value : '';
          self.custom_drop_options_2 = bids
          let pictures = (typeof d.custom_fields_dropdowns[2] != 'undefined') ? d.custom_fields_dropdowns[2].drop_value : '';
          self.custom_drop_options_3 = pictures
          let customField4Option = (typeof d.custom_fields_dropdowns[3] != 'undefined') ? d.custom_fields_dropdowns[3].drop_value : '';
          self.custom_drop_options_4 = customField4Option
          let customField5Option = (typeof d.custom_fields_dropdowns[4] != 'undefined') ? d.custom_fields_dropdowns[4].drop_value : '';
          self.custom_drop_options_5 = customField5Option
          let customField6Option = (typeof d.custom_fields_dropdowns[5] != 'undefined') ? d.custom_fields_dropdowns[5].drop_value : '';
          self.custom_drop_options_6 = customField6Option
          self.progressionValuesData = d.progression_values;
          self.isLoading = false;

        }
      })
    },
    selectedAccountDrop (query){
      let self = this;
      self.existingAccount = query
      this.selectSearchAccount(query.id);
    },
    validator(validate) {
        return validate === '' || validate === null
    },
    validateData() {
      let submitSuccess = true;
      if (submitSuccess == true && !this.selectedAccount.id) {
        Vue.$toast.error('Select Account', {
                position: 'top'
            });
        submitSuccess = false;
      }
      else if ( submitSuccess == true && this.validator(this.jobData.name)) {
           Vue.$toast.error('Enter Job Name', {
                position: 'top'
            });
          submitSuccess = false
      } else if (submitSuccess == true && this.validator(this.jobData.job_number)) {
        Vue.$toast.error('Enter Job Number', {
                position: 'top'
            });
        submitSuccess = false
      } else if ( submitSuccess == true && this.validator(this.jobData.bid_date)) {
        Vue.$toast.error('Enter Bid Date', {
                position: 'top'
            });
        submitSuccess = false
      } else if (submitSuccess == true && this.validator(this.jobData.status)) {
        Vue.$toast.error('Select Current Status', {
                position: 'top'
            });
        submitSuccess = false
      } else if (submitSuccess == true && this.validator(this.jobData.accounting)) {
        Vue.$toast.error('Select Accountant', {
                position: 'top'
            });
        submitSuccess = false
      } else if (submitSuccess == true && this.validator(this.jobData.estimator)) {
        Vue.$toast.error('Select Estimator', {
                position: 'top'
            });
        submitSuccess = false
      } else if (submitSuccess == true && this.validator(this.jobData.project_manager)) {
        Vue.$toast.error('Select Project Manager', {
                position: 'top'
            });
        submitSuccess = false
      } else if (submitSuccess == true && this.validator(this.jobData.foreman)) {
        Vue.$toast.error('Select Foreman', {
                position: 'top'
            });
        submitSuccess = false
      } else if (submitSuccess == true && this.validator(this.jobData.progress_status)) {
        Vue.$toast.error('Select Progress Status', {
                position: 'top'
            });
        submitSuccess = false
      } else {
        submitSuccess = true
      }
      if(submitSuccess == true)
        this.getAddressMapData()
    },
    getAddressMapData(){
        let self = this

        let address = self.jobData.site_address_1 + ", "+self.jobData.site_address_2 + ", "+self.jobData.site_city + ", "+self.jobData.site_state + ", "+self.jobData.site_zip
        if (self.jobData.site_address_1 != '' || self.jobData.site_address_2 != '') {
          let geocoder = new google.maps.Geocoder();
          let latitude = ''
          let longitude = ''
          geocoder.geocode({'address': address}, function (results, status) {
            self.googleMapLog.address = address;
            self.googleMapLog.api_response = JSON.stringify(results);
            self.googleMapLog.api_status = status;
            if (status == google.maps.GeocoderStatus.OK) {
              latitude = results[0].geometry.location.lat();
              longitude = results[0].geometry.location.lng();
              if (longitude && latitude) {
                self.jobData.site_longitude = longitude.toString()
                self.jobData.site_latitude = latitude.toString()
                self.createNewJob()
              } else {
                self.createNewJob()
              }
            } else {
              if (confirm("Entered site address is not valid, Are you sure you want to save?")) {
                self.jobData.site_longitude = ''
                self.jobData.site_latitude = ''
                self.createNewJob();
              }
            }
          });
        } else {
          self.createNewJob()
        }
      },
    createNewJob() {
        let self = this;
        self.isLoading = true;
        let data = {};
        data = {
          "custom_text_1": this.jobData.custom_text_1,
          "custom_text_2": this.jobData.custom_text_2,
          "custom_text_3": this.jobData.custom_text_3,
          "custom_text_4": this.jobData.custom_text_4,
          "custom_text_5": this.jobData.custom_text_5,
          "custom_text_6": this.jobData.custom_text_6,
          "bid_date": this.jobData.bidDate,
          "estimator_deadline": this.jobData.estimator_deadline,
          "estimator_priority": this.jobData.estimator_priority,
          "production_deadline": this.jobData.production_deadline,
          "production_priority": this.jobData.production_priority,
          "completed_date": this.jobData.completed_date,
          "job_contacts": "",
          "new_account": "0",
          "new_account_name": '',
          "new_account_email": '',
          "new_account_phone": '',
          "new_account_mobile": '',
          "new_account_fax": '',
          "new_account_address_1": '',
          "new_account_address_2": '',
          "new_account_city": '',
          "new_account_state": '',
          "new_account_zip": '',
          "new_contact_title": '',
          "new_contact_first_name": '',
          "new_contact_last_name": '',
          "new_contact_email": '',
          "new_contact_phone": '',
          "new_contact_mobile": '',
          "new_contact_fax": '',
          "new_contact_address_1": '',
          "new_contact_address_2": '',
          "new_contact_city": '',
          "new_contact_state": '',
          "new_contact_zip": '',
          "assigned_job_account": this.selectedAccount.id,
          "primary_contact": this.jobData.primary_contact,
          "name": this.jobData.name,
          "job_number": this.jobData.job_number,
          "status": this.jobData.status,
          "progress_status" : this.jobData.progress_status,
          "estimator": this.jobData.estimator,
          "project_manager": this.jobData.project_manager,
          "foreman": this.jobData.foreman,
          "accounting": this.jobData.accounting,
          "salesman" : this.jobData.salesman ? this.jobData.salesman : '',
          "prime_contract": this.jobData.prime_contract,
          "site_address_1": this.jobData.site_address_1,
          "site_address_2": this.jobData.site_address_2,
          "site_city": this.jobData.site_city,
          "site_state": this.jobData.site_state,
          "site_zip": this.jobData.site_zip,
          "billing_address_1": this.jobData.billing_address_1,
          "billing_address_2": this.jobData.billing_address_2,
          "billing_city" : this.jobData.billing_city,
          "billing_state": this.jobData.billing_state,
          "billing_zip": this.jobData.billing_zip,
          "siteLatitude": this.jobData.site_latitude,
          "siteLongitude": this.jobData.site_longitude,
          "billingLatitude": 0.00,
          "billingLongitude": 0.00,
          "google_api_status": self.googleMapLog.api_status,
          "google_api_reponse": self.googleMapLog.api_response,
          "google_api_address": self.googleMapLog.address
        };

        data.lead_source = this.jobData.lead_source && (this.jobData.lead_source != null) && (this.jobData.lead_source != '') ? this.jobData.lead_source : '';
        data.custom_drop_1 = this.jobData.custom_drop_1 && (this.jobData.custom_drop_1 != null) && (this.jobData.custom_drop_1 != '') ? this.jobData.custom_drop_1 : '';
        data.custom_drop_2 = this.jobData.custom_drop_2 && (this.jobData.custom_drop_2 != null) && (this.jobData.custom_drop_2 != '') ? this.jobData.custom_drop_2 : '';
        data.custom_drop_3 = this.jobData.custom_drop_3 && (this.jobData.custom_drop_3 != null) && (this.jobData.custom_drop_3 != '') ? this.jobData.custom_drop_3 : '';
        data.custom_drop_4 = this.jobData.custom_drop_4 && (this.jobData.custom_drop_4 != null) && (this.jobData.custom_drop_4 != '') ? this.jobData.custom_drop_4 : '';
        data.custom_drop_5 = this.jobData.custom_drop_5 && (this.jobData.custom_drop_5 != null) && (this.jobData.custom_drop_5 != '') ? this.jobData.custom_drop_5 : '';
        data.custom_drop_6 = this.jobData.custom_drop_6 && (this.jobData.custom_drop_6 != null) && (this.jobData.custom_drop_6 != '') ? this.jobData.custom_drop_6 : '';

        axios.post(this.constants.api_url + 'job/create/new', data, {headers: {
          'Content-type': "application/json",
          'token': localStorage.getItem('token')
        }})
          .then(function (respone) {

            if (respone.data.flag) {
              self.isLoading = false;
              let jobid = respone.data.data.id;
              Vue.$toast.success('Job created successfully', {
                position: 'top'
            });
              self.$router.push('/job/' + jobid);
            } else {
                Vue.$toast.error(respone.data.message, {
                  position: 'top'
              });
              self.isLoading = false;
            }
          }).catch(function (error) {
            Vue.$toast.error(error, {
                position: 'top'
            });
            self.isLoading = false;
        })
      },
    addNewJobModal(){
      this.$refs['my-modal-add'].show();
    },
    selectAccountModal(){
      this.$refs['my-modal-select'].show();
    },
    closeAddModal(){
      this.$refs['my-modal-add'].hide();
    },
    closeSelectModal(){
      this.$refs['my-modal-select'].hide();
    },
    selectExistingAccount(){
      this.selectedAccount.name =  this.existingAccount.value;
      this.selectedAccount.id =  this.existingAccount.id;
      this.accountFlag = 'selected';
      this.$refs['my-modal-select'].hide();

    },
    selectSearchAccount(id) {
        let self = this
        axios.get(this.constants.api_url + 'account/contacts/' + id, {headers: {
          'Content-type': "application/json",
          'token': localStorage.getItem('token')
        }})
          .then(function (response) {
            self.selectedContact = response.data.data.contacts
          })
    },
    useAccount (){
      this.contact.email = this.account.email;
      this.contact.phone = this.account.phone;
      this.contact.mobile = this.account.mobile;
      this.contact.fax = this.account.fax;
      this.contact.address1 = this.account.address1;
      this.contact.address2 = this.account.address2;
      this.contact.city = this.account.city;
      this.contact.state = this.account.state;
      this.contact.zip = this.account.zip;
    },
    addAccount() {
        let self = this;
        this.error = []
        let flag = false;
        if (self.account.name == '') {
          Vue.$toast.error('Please enter account name', {
                position: 'top'
            });
          flag = true;
        }
        if (self.contact.firstName == '' && flag == false) {
          Vue.$toast.error('Please enter contact first name', {
                position: 'top'
            });
          flag = true;
        }
        if (self.contact.lastName == '' && flag == false) {
          Vue.$toast.error('Please enter contact last name', {
                position: 'top'
            });
          flag = true;
        }
        if (self.contact.email == '' && flag == false) {
          Vue.$toast.error('Please enter contact email', {
                position: 'top'
            });
          flag = true;
        }

        let reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z])/;
        if (self.account.email != '' && flag == false) {
          if (reg.test(self.account.email) == false && flag == false) {
            Vue.$toast.error('Enter valid account email', {
                position: 'top'
            });
            flag = true;
          }
        }
        if (reg.test(self.contact.email) == false && flag == false) {
          Vue.$toast.error('Enter valid contact email', {
                position: 'top'
            });
          flag = true;
        }
        if (!flag) {
          let request = {
            "company_id": JSON.parse(localStorage.getItem('userData')).company_id,
            "account_name": self.account.name,
            "account_email": self.account.email,
            "account_phone": self.account.phone,
            "account_mobile": self.account.mobile,
            "account_fax": self.account.fax,
            "account_address_1": self.account.address1,
            "account_address_2": self.account.address2,
            "account_city": self.account.city,
            "account_state": self.account.state,
            "account_zip": self.account.zip,
            "account_status": self.account.status,
            "account_contact_type": "new_contact",
            "contact_title": self.contact.title,
            "contact_first_name": self.contact.firstName,
            "contact_last_name": self.contact.lastName,
            "contact_email": self.contact.email,
            "contact_phone": self.contact.phone,
            "contact_mobile": self.contact.mobile,
            "contact_fax": self.contact.fax,
            "contact_address_1": self.contact.address1,
            "contact_address_2": self.contact.address2,
            "contact_city": self.contact.city,
            "contact_state": self.contact.state,
            "contact_zip": self.contact.zip,
            "salesman": self.account.salesman ? self.account.salesman : ''
          };

          axios.post(self.constants.api_url + 'account/create', request, {headers: {
          'Content-type': "application/json",
          'token': localStorage.getItem('token')
        }})
            .then(function (response) {
              if (response.data.flag) {
                 Vue.$toast.success('Account added successfully', {
                position: 'top'
                });
                self.selectedAccount.name = response.data.data.account.name;
                self.selectedAccount.id = response.data.data.account.id;
                self.selectedContact.push(response.data.data.contact);
                self.accountFlag = 'selected';
                self.$refs['my-modal-add'].hide();

              } else {
                 Vue.$toast.error(response.data.message.name, {
                position: 'top'
                });
              }
            })
        } else {
           Vue.$toast.error(response.data.message.name, {
                position: 'top'
                });
        }
      },
  }

}
</script>

<style>

</style>
